import { Instagram, Facebook, Linkedin } from "lucide-react";
import { TikTok } from "@/components/icons/TikTok";
import kokoomusLogo2 from "@/assets/kokoomus-logo-2.png";

const Footer = () => (
  <footer className="relative overflow-hidden bg-secondary px-6 py-14">
    <div className="relative z-10 mx-auto flex max-w-6xl flex-col items-center gap-6">
      <img
        src={kokoomusLogo2}
        alt="Kokoomus logo"
        className="h-28 w-auto opacity-90 md:h-36"
      />
      <div className="flex flex-col items-center gap-4">
        <div className="flex flex-col items-center gap-3 md:flex-row md:gap-4">
          <span className="font-display text-xl italic text-secondary-foreground/80">
            Seuraa miuta somessa!
          </span>
          <div className="flex items-center gap-3">
            {[
              { href: "https://www.instagram.com/ellosenlotta", icon: Instagram },
              { href: "https://www.facebook.com/lottaellonen", icon: Facebook },
              { href: "https://www.linkedin.com/in/lottaellonen", icon: Linkedin },
              { href: "https://www.tiktok.com/@morrikka_", icon: TikTok },
            ].map(({ href, icon: Icon }, i) => (
              <a
                key={i}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-full p-3 text-secondary-foreground/70 transition-colors hover:text-primary"
              >
                <Icon className="h-6 w-6" />
              </a>
            ))}
          </div>
        </div>
        <p className="text-base font-bold text-white/85">
          © Sinisellä Sydämellä ry &lt;3
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
